module.exports = __webpack_public_path__ + "img/icon-tw.72833e6f.svg";